<app-header></app-header>
<app-menubar></app-menubar>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-loader *ngIf="showLoader"></app-loader>